import { Modal } from 'components/Modal/Modal';
import React from 'react';
import styles from './MobileDrawer.module.scss';

type MobileDrawerProps = {
  modalId: string;
  onClose: () => void;
  modalBody: JSX.Element;
  modalHeader?: JSX.Element;
};

export const MobileDrawer = ({ modalId, onClose, modalBody, modalHeader }: MobileDrawerProps) => {
  return (
    <Modal
      position="bottom"
      modalId={modalId}
      onClose={onClose}
      modalContentClass={styles.mobileDrawer}
      modalBody={modalBody}
      modalHeader={modalHeader}
      fullwidth
      isAnimatedDrawer
    />
  );
};
